import React from 'react';

export function AccessDenied() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      textAlign: 'center',
      padding: '20px'
    }}>
      <h1>Access Denied</h1>
      <p>You do not have permission to view this page.</p>
      <p>Please contact your administrator if you believe this is an error.</p>
    </div>
  );
}
